<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="50%"
    :innerScroll="false"
    :loading="loadingBtn"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品编码:">{{ form.productCode }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称:">{{ form.productName }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="基础零售价:" prop="retailPrice">
            <el-input-number
              v-model="form.retailPrice"
              :precision="0"
              :min="0"
              :controls="false"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="A类价系数:" prop="dailyRetailPrice">
            <el-input-number
              v-model="form.dailyRetailPrice"
              :precision="5"
              :min="0"
              :controls="false"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="清仓销售价系数:" prop="discountPriceClear">
            <el-input-number
              v-model="form.discountPriceClear"
              :precision="5"
              :min="0"
              :controls="false"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="调整原因:" prop="reason">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.reason"
              maxlength="300"
              show-word-limit
              placeholder="请输入调整原因"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'RetailPriceEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      form: {
        id: undefined,
        productCode: '',
        productName: '',
        retailPrice: undefined,
        dailyRetailPrice: undefined,
        discountPriceClear: undefined,
        reason: '',
      },
      rules: {},
    };
  },
  created() {
    this.initForm();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    initForm() {
      Object.keys(this.form).forEach((key) => {
        if (key in this.row) {
          this.form[key] = this.row[key] || undefined;
        }
      });
    },
    onConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        const data = { ...this.form, id: this.row.id };
        this.$q.product
          .updateProductRetailPrice({ data })
          .then((res) => {
            if (res.code === '200') {
              this.$message.success('编辑成功');
              this.isVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
